import styled from 'styled-components';
import { EERIE, MARIGOLD } from 'HubStyleTokens/colors';
export const ColorIndicator = styled.div.withConfig({
  displayName: "ColorIndicator",
  componentId: "o2fcpv-0"
})(["position:absolute;top:0;bottom:0;left:0;width:4px;background-color:", ";"], ({
  forwarded
}) => forwarded ? MARIGOLD : EERIE);